module.exports = __webpack_public_path__ + "static/media/lineRed.6eb876eb.PNG";